<template>
<div>
  <v-dialog v-model="dialog" persistent max-width="500">
    <v-card>
      <v-card-title class="primary white--text">Kirim Pesan</v-card-title>
      <v-card-text>
        <v-list-item>
          <v-list-item-avatar v-if="newmessage.touser.avatar">
            <v-img contain :src="newmessage.touser.avatar"></v-img>
          </v-list-item-avatar>
          <v-list-item-avatar v-else>
            <v-img contain src="https://res.cloudinary.com/dd5jfnv3x/image/upload/v1519482855/default-image.png"></v-img>
          </v-list-item-avatar>
          <v-list-item-content class="">
            <v-list-item-title>{{newmessage.touser.membername}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-textarea outlined label="Pesan" v-model="postdata.msg" rows="2"></v-textarea>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn elevation="0" dark @click="setdialog(false)" color="red">Batal</v-btn>
        <v-btn elevation="0" dark @click="kirimpesan" color="primary">Kirim</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DialogNewMessage',
  data: () => ({
    postdata: {
      groupid: 0,
      to: 0,
      image: '',
      msg: ''
    }
  }),
  computed: {
    ...mapState('ChatStore', ['dialog', 'newmessage'])
  },
  methods: {
    ...mapActions('ChatStore', ['setdialog', 'sendMessage']),
    kirimpesan () {
      if (this.postdata.msg.length > 1) {
        this.postdata.to = this.newmessage.touser.memberid
        this.sendMessage(this.postdata)
        this.setdialog(false)
        this.postdata.msg = ''
        this.postdata.image = ''
        this.postdata.to = 0
      }
    }
  }
}
</script>

<style scoped>

</style>
